@if (!item.hidden) {
  @if (!item.hideGroupTitleFlag) {
    <div [ngClass]="item.classes" class="group-title fxl-column fxla-center-start">
      @if (item.text2) {
        <div class="hint-text primary-fg sub-hint-text">{{ item.text2 }}</div>
      }
      <div>
        @if (item.translate) {
          <span [translate]="item.translate" class="hint-text"></span>
        }
        @if (item.text) {
          <span class="hint-text" id="laboratory-name">{{ item.text }}</span>
        }
      </div>
    </div>
  }
  <div class="group-items">
    @for (item of item.children; track item.id) {
      @if (item.type === 'group') {
        <app-nav-group [item]="item"></app-nav-group>
      }
      @if (item.type === 'collapsable') {
        <app-nav-collapsable [item]="item"></app-nav-collapsable>
      }
      @if (item.type === 'item') {
        <app-nav-item [item]="item"></app-nav-item>
      }
    }
  </div>
}
